

import Vue from 'vue'

let utils = {
    /**
     * 获取url传递参数
     */
    getUrlKey(name){
        return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
    },
   //节流函数-防止重复点击
    throttle(fn, time) {
        if (time == null || time == undefined) {
        time = 2000
        }
    
        let _lastTime = null
        return function () {
        let _nowTime = +new Date()
        if (_nowTime - _lastTime > time || !_lastTime) {
            fn.apply(this, arguments)
            _lastTime = _nowTime
        }
        }
    }
  

      
    
}
export default utils